import api, {
  buildQueryParams,
  IGetQueryParams,
  IPaginatedRepsonse,
} from './index';
import {
  IAccountantRecommendation,
  IProject,
  ProjectsResponse,
  ProjectStatusType,
} from './responseTypes';
import { IUser } from './user';
export type IPromoCode = {
  id: number;
  code: string;
  percentage: number;
  valid_from: string;
  valid_to: string;
  is_one_use: boolean;
  created_at: string;
  updated_at: string;
};

export const PormoCodesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPromocode: builder.query<IPromoCode, string>({
      query: (promocode) => `promo_codes/code/${promocode}`,
      transformResponse: (response: { promo_code: IPromoCode }) =>
        response.promo_code,
    }),
    getPromoCodes: builder.query<
      IPaginatedRepsonse<IPromoCode>,
      IGetQueryParams<{}>
    >({
      query: (params) => `/promo_codes${buildQueryParams(params)}`,
    }),

    updatePromoCode: builder.mutation<
      IPromoCode,
      Partial<IPromoCode> & { id: number }
    >({
      query: (promo_code) => ({
        url: `/promo_codes/${promo_code.id}`,
        method: 'PUT',
        body: { promo_code },
      }),
    }),
    createPromoCode: builder.mutation<IPromoCode, IPromoCode>({
      query: (promo_code) => ({
        url: `/promo_codes`,
        method: 'POST',
        body: { promo_code },
      }),
    }),
    deletePromoCode: builder.mutation({
      query: (id: number) => ({
        url: `/promo_codes/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useLazyGetPromocodeQuery,
  useCreatePromoCodeMutation,
  useDeletePromoCodeMutation,
  useGetPromoCodesQuery,
  useLazyGetPromoCodesQuery,
  useUpdatePromoCodeMutation,
} = PormoCodesApi;
